import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { FORMULAS } from "../data/content";
import { SectionTitle } from "./Brand";
import { Reveal } from "./Reveal";

const FormulaCard = ({ formula, index }) => (
    <motion.article
        data-testid={`formula-card-${formula.id}`}
        initial={{ opacity: 0, y: 44 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.75, delay: index * 0.16, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ y: -8 }}
        className={`group relative flex flex-col rounded-3xl bg-panel p-7 transition-shadow duration-500 sm:p-8 ${
            formula.popular
                ? "card-line glow-strong"
                : "card-line glow-soft hover:shadow-[0_0_0_1px_rgba(0,240,255,0.3),0_18px_60px_-14px_rgba(0,240,255,0.3)]"
        }`}
    >
        {formula.popular && (
            <span
                data-testid="formula-popular-badge"
                className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-neon px-4 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-noir"
            >
                Populaire
            </span>
        )}

        <header className="mb-6 text-center">
            <img
                src={formula.img}
                alt={`Formule ${formula.name} — ${formula.price}`}
                data-testid={`formula-badge-${formula.id}`}
                className="mx-auto w-full max-w-[230px] object-contain"
                loading="lazy"
            />
            <p className="mt-4 font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-neon/90">
                {formula.tag}
            </p>
            <p data-testid={`formula-price-${formula.id}`} className="sr-only">
                {formula.name} — {formula.price}
            </p>
        </header>

        {formula.includes && (
            <p className="mb-4 text-center text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                {formula.includes}
            </p>
        )}

        <ul className="mb-8 flex-1 space-y-3">
            {formula.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-slate-300">
                    <Check size={16} className="mt-0.5 shrink-0 text-neon" strokeWidth={3} />
                    {f}
                </li>
            ))}
        </ul>

        <Link
            to={`/reservation?formule=${formula.id}`}
            data-testid={`reserve-${formula.id}-button`}
            className="rounded-full bg-neon py-3.5 text-center text-sm font-bold tracking-wide text-noir transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_30px_rgba(0,240,255,0.45)]"
        >
            {formula.cta}
        </Link>
    </motion.article>
);

const Formulas = () => (
    <section id="formules" data-testid="formulas-section" className="relative py-24 sm:py-32">
        <div className="halo pointer-events-none absolute left-1/2 top-0 h-[28rem] w-[40rem] -translate-x-1/2 rounded-full opacity-60" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
            <Reveal>
                <SectionTitle
                    eyebrow="Nos formules"
                    title="Trois niveaux de brillance"
                    sub="Nettoyage voiture à domicile, du lavage essentiel à la remise en état complète. Prix nets, sans surprise, partout sur Cannes & alentours."
                />
            </Reveal>
            <div className="grid gap-8 md:grid-cols-3 md:gap-6 lg:gap-8">
                {FORMULAS.map((f, i) => (
                    <FormulaCard key={f.id} formula={f} index={i} />
                ))}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-10 text-center text-sm text-slate-500">
                    Une demande particulière ?{" "}
                    <a href="#contact" className="font-semibold text-neon underline-offset-4 hover:underline">
                        Demandez un devis sur mesure
                    </a>
                </p>
            </Reveal>
        </div>
    </section>
);

export default Formulas;
